import React from "react";
import { Menu, Layout, Avatar  } from 'antd';
import { AntDesignOutlined } from '@ant-design/icons';
const { Sider } = Layout;

const LeftList = [
    {name:'我的申请',ico:<i className="iconfont">&#xe601;</i>},
    {name:'我的登记',ico:<i className="iconfont">&#xe606;</i>},
    {name:'我的预约',ico:<i className="iconfont">&#xe602;</i>},
    {name:'我的账单',ico:<i className="iconfont">&#xe604;</i>},
    {name:'我的合同',ico:<i className="iconfont">&#xe608;</i>},
    // {name:'我的收藏',ico:<i className="iconfont">&#xe609;</i>},
    {name:'消息通知',ico:<i className="iconfont">&#xe603;</i>},
    {name:'我的租情直通车',ico:<i className="iconfont">&#xe608;</i>},
    {name:'个人资料',ico:<i className="iconfont">&#xe605;</i>},
]

class Lefter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            current:'0'
        }
    }
    tableBody = (item, index) => {
        return (
            <Menu.Item key={index} id={'LeftDom'}>
               {item.ico}&nbsp;{item.name}
            </Menu.Item>
        );
    }
    handleClick =(e)=>{
        this.setState({
            current:e.key
        })
        this.props.getMyTransactionList(e.key)
    }
    render() {
        const { userLoginInfo,selectable } =this.props
        const { current } =this.state
        console.log(selectable)
        return (
            <div id="components-layout-demo-responsive">
                <Sider
                    breakpoint="lg"
                    collapsedWidth="0"
                    onBreakpoint={broken => {
                        // console.log(broken);
                    }}
                    onCollapse={(collapsed, type) => {
                        // console.log(collapsed, type);
                    }}
                >
                    <div className="logo" >
                        <Avatar
                            size={{ xs: 64, sm: 64, md: 64, lg: 64, xl: 80, xxl: 100 }}
                            icon={<AntDesignOutlined />}
                        />
                        <span style={{display:'block',fontSize: '20px',fontWeight: '500',color: '#000000',paddingTop:'12px'}}>{userLoginInfo.username}</span>
                    </div>
                    <Menu theme="light" mode="inline" onClick={this.handleClick} selectedKeys={[selectable?selectable:current]}>
                        {LeftList.map(this.tableBody)}
                    </Menu>
                </Sider>
            </div>
        )
    }
}



export default Lefter
